import React, { Component } from "react";
import { connect } from "react-redux";
import classnames from "classnames";

import styles from "./AssociationSlide.local.scss";

import { ModalConfirm } from "tamtam-components";

import _ from "i18n";
import AssociationLegalForme from "../Common/AssociationLegalForme/AssociationLegalForme";

class AssociationSlide extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: true,
      isOpenModal: false
    };
  }

  handleDisabled = disabled => {
    this.setState({ disabled: disabled });
  };

  handleCancelAssociationModal = () => {
    const { disabled } = this.state;
    if (!disabled) {
      this.setState({ isOpenModal: true });
    } else {
      this.props.handleCancelAssociationModal();
      this.setState({ disabled: true });
    }
  };

  render() {
    const { isAssociationSlide } = this.props;
    let { isOpenModal, disabled } = this.state;

    return (
      <div
        className={classnames(
          styles.sidebar,
          isAssociationSlide ? styles.display : ""
        )}
      >
        <img
          src={"/img/icons/close.svg"}
          className={styles.sidebar__close}
          onClick={this.handleCancelAssociationModal}
          alt={""}
        />

        <div className={styles.sidebar__titles}>
          <h4>{_("associationLegalForm")}</h4>
        </div>
        <AssociationLegalForme
          handleCancelAssociationModal={this.handleCancelAssociationModal}
          handleDisabled={this.handleDisabled}
          disabled={disabled}
        />

        <ModalConfirm
          type={"return"}
          isOpen={isOpenModal}
          onCancel={() => {
            this.setState({ isOpenModal: false });
            this.setState({ disabled: false });
          }}
          onConfirm={() => {
            this.props.handleCancelAssociationModal();
            this.setState({ disabled: true });
            this.setState({ isOpenModal: false });
          }}
          inProcess={false}
          actionFailed={false}
          title={_("cancelConfirm")}
          text={_("cancelConfirmContent")}
          labelNo={_("cancel")}
          labelYes={_("exit")}
          labelError={"Error"}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({});

export default connect(mapStateToProps)(AssociationSlide);



// WEBPACK FOOTER //
// ./src/components/OrganizationList/AssociationSlide.js